import axios from 'axios';
import vue from '../main.js'

const getAuthToken = ()=>{
	return localStorage.getItem('WIZARD_MEMBER_TOKEN');
}

const setAuthToken = (value)=>{
	localStorage.setItem('WIZARD_MEMBER_TOKEN',value);
}

const request = (method,url,data,headers)=>{
	let requestHeaders = {};
	let token = getAuthToken();
	if(token) requestHeaders.token = token;
	if(method == 'get'){
		requestHeaders['Content-Type'] = "application/x-www-form-urlencoded";
	}else{
		requestHeaders['Content-Type'] = "application/json";
	}
	if(headers){
		requestHeaders = Object.assign({},requestHeaders,headers);
	}
	
	let config = {
		baseURL:process.env.VUE_APP_HTTP_URL,
		method,
		url,
		data,
		headers:requestHeaders
	}
	if(typeof data == 'object' && requestHeaders['Content-Type'] == 'application/x-www-form-urlencoded'){
		data = Object.keys(data)
	                   .map(function(key){
	                   	return encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
	                   })
	                   .join("&")
	                   .replace(/%20/g, "+");
		if(method == 'post') config.data = data;
		else config.url += '?'+data;
	}
	return axios(config);
}

var get = (url,data,contentType)=>{
	return request('get',url,data,contentType);
}

var post = (url,data,contentType)=>{
	return request('post',url,data,contentType);
}


axios.interceptors.response.use(function (response) {
	if(process.env.NODE_ENV == 'development'){
		console.log(response);
	}
	if(response.data.code == 10002){
		vue.$alert(vue.$t('default.VerificationCodeError'));
	}
	if(response.data.code == 1008){
		vue.$alert(vue.$t('login.PhonwHasReged'));
	}
	if(response.data.code == 1009){
		vue.$alert(vue.$t('login.PhoneNotReged'));
	}
	return response.data;
}, function (error) {
	if(process.env.NODE_ENV == 'development'){
		console.log(error.response);
	}

	if(error.response.status == 403){
		//location.href = '/';
		return {code:403,msg:"请重新登录"}
	}
	if(error.response.status == 401){
		//location.href = '/';
		return {code:401,msg:"请重新登录"}
	}

	if(error.response && error.response.data){
		//vue.$message.error(error.response.data.error_msg)
		return {code:error.response.status,data:error.response.data}
	}else{
		return {code:error.response.status,data:{error:error.response.statusText,error_msg:error.message}}
	}
	
});




let modules = {
	request,
	get,
	post,
	getAuthToken,
	setAuthToken
}


export default modules